import * as React from 'react';
import { cn } from '../utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    // biome-ignore lint/a11y/noLabelWithoutControl: primitive wrapper, consumers provide htmlFor or children control
    <label
      ref={ref}
      className={cn('text-[12px] font-medium text-[var(--color-text-secondary)]', className)}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
